import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/healthcheck';
import { HealthcheckInfo } from '@rootCommon/types/healthcheck';
import { ResultState } from '@rootCommon/types/common';

type Action = ActionType<typeof actions>;
export type HealthcheckState = ResultState<HealthcheckInfo | null>;

const initialState: HealthcheckState = {
  data: null,
  loading: false,
  error: null,
};

export const healthcheckReducer = (state = initialState, action: Action): HealthcheckState => {
  switch (action.type) {
    case getType(actions.fetchHealthcheck.request):
      return { ...state, loading: true };
    case getType(actions.fetchHealthcheck.success):
      return {
        ...state, loading: false, error: null, data: action.payload,
      };
    case getType(actions.fetchHealthcheck.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default healthcheckReducer;
